import { useCallback, useEffect } from "react";
import { useCookieBotConsentReady } from "src/analytics/hooks/use-cookie-bot-consent-ready";
import { isValidLocale } from "src/constants/locale";
import { useDisclaimerStore } from "src/stores/disclaimer-store";
import { isServerSide } from "src/utils/common-util";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { useFirstInteraction } from "./use-first-interaction";

export const useDisclaimerCheck = (disclaimer?: string | null) => {
    const { tryChangeCountry, markDisclaimerNotRequired } = useDisclaimerStore();
    const isCookieBotConsentReady = useCookieBotConsentReady();

    let countryFromPathName = undefined;

    const { country, language } = useRouterLocale();

    // TODO: WIKI-32459
    // Workaround for an old issue where the Next.js Link click triggers rehydration
    // with incorrect country and locale, which is later replaced in next/router.

    if (!isValidLocale({ language, country }) && !isServerSide()) {
        countryFromPathName = window.location.pathname.split("/").filter(Boolean)[1];
    }

    const isDisclaimerAlreadyAccepted = country === disclaimer || countryFromPathName === disclaimer;

    const handleOnFirstInteraction = useCallback(() => tryChangeCountry(country, true), [tryChangeCountry, country]);

    useEffect(() => {
        if (!isDisclaimerAlreadyAccepted) {
            return;
        }

        markDisclaimerNotRequired();
    }, [isDisclaimerAlreadyAccepted, markDisclaimerNotRequired]);

    useFirstInteraction({
        isDisabled: isDisclaimerAlreadyAccepted || !isCookieBotConsentReady,
        onFirstInteraction: handleOnFirstInteraction,
    });
};
